import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
/* reducer */
import * as fromAccommodationDataStore from './state/accommodation-data-store.reducer';

/* effects */
import { AccommodationDataStoreEffects } from './state/accommodation-data-store.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,

    /* AccommodationDataStore State */
    StoreModule.forFeature(
      fromAccommodationDataStore.featureKey,
      fromAccommodationDataStore.reducer,
      { initialState: fromAccommodationDataStore.initialState },
    ),
    EffectsModule.forFeature([AccommodationDataStoreEffects]),
  ],
  exports: [StoreModule, EffectsModule],
})
export class AccommodationDataStoreModule {}
